// extracted by mini-css-extract-plugin
export default {"sidePanel":"InferenceInspectorPage-styles-module--sidePanel--gUINc"};